import React, { useEffect, useState } from "react";
import Header from "../components/Sections/Header";
import CallToAction from "../components/Sections/CallToAction";
import Services from "../components/Sections/Services";
import Testimonials from "../components/Sections/Testimonials";
import UserDashboard from "./userDashboard";

export default function Landing() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  useEffect(() => {
    const user = localStorage.getItem("user");
    setIsLoggedIn(!!user);
    if (user) {
      setIsLoggedIn(true);
    }
  }, []);

  if (isLoggedIn) {
    return <UserDashboard />;
  }

  return (
    <>
      <Header />
      <Services />
      <Testimonials />
      <CallToAction />
    </>
  );
}
